
import m from "mithril";
import dayjs from 'dayjs';
import MessageProvider from "../../../MessageProvider";
import { BookingDetail} from "../../../Models";
import './FindBookingPage.css'
import { getValueByLang } from "../../../Utils";

interface Attrs {    
    booking: BookingDetail,
    messageProvider: MessageProvider;
    onViewDetails: (booking: BookingDetail) => void;
}
export default function BookingSummaryComponent(): m.Component<Attrs> {
    return {
        view(vnode) { 
            const {booking, messageProvider, onViewDetails} = vnode.attrs;    

            let getNumberOfNight = (checkInDate:string, checkOutDate: string): number => {
                let differentInTime = new Date(checkOutDate).getTime() - new Date(checkInDate).getTime();
                return differentInTime / (1000 * 3600 * 24);
            };
            return [
                m("div.row", [
                    m("div.col-md-1 d-none d-md-block", 
                        m("img.w-100 h-100 rounded-16", {src: booking.hotel.featuredPhotoUrl})
                    ),
                    m("div.col-md-11 col-12", [
                        m("div.row",
                            m("div.col-md-4 d-none d-md-block pl-4", [
                                m("div", getValueByLang(booking.hotel.name, messageProvider.getCurrentLang())),
                                m("div", [
                                    m("small", messageProvider.get("booking_reference") + " : "), m("small.font-weight-bold", booking.reference)
                                ]),
                                
                            ]),
                            m("div.col-12 d-block d-md-none", [
                                m("div.font-weight-bold", getValueByLang(booking.hotel.name, messageProvider.getCurrentLang())),
                                m("div", [
                                    m("small", messageProvider.get("booking_reference") + " : "), m("small.font-weight-bold", booking.reference)
                                ]),
                                
                            ]),
                            m("div.col-md-4 d-none d-md-block text-center", [
                                m("div.border-bottom", m("small.font-weight-bold", dayjs(booking.checkInDate).format("MMM D, YYYY") + " - " + dayjs(booking.checkOutDate).format("MMM D, YYYY"))),
                                m("div", [
                                    m("small", [
                                        m("span", booking.numberOfRooms + +" " + ((booking.numberOfRooms > 1)? messageProvider.get("rooms"): messageProvider.get("room")) + ", " ),
                                        m("span", getNumberOfNight(booking.checkInDate, booking.checkOutDate) + " " + 
                                        ((getNumberOfNight(booking.checkInDate, booking.checkOutDate) > 1)? messageProvider.get("nights"): messageProvider.get("night")))
                                    ])
                                ])
                            ]),
                            m("div.col-12 d-block d-md-none", [
                                m("div", [
                                    m("small", messageProvider.get("checkin_date") + " / "+ messageProvider.get("checkout_date") + " : "), 
                                    m("small.font-weight-bold", dayjs(booking.checkInDate).format("MMM D, YYYY") + " - " + dayjs(booking.checkOutDate).format("MMM D, YYYY"))
                                ]),
                                m("div", [
                                    m("small", messageProvider.get("number_of_room") + " : "),
                                    m("small.font-weight-bold", [
                                        m("span", booking.numberOfRooms + +" " + ((booking.numberOfRooms > 1)? messageProvider.get("rooms"): messageProvider.get("room")) + ", " ),
                                        m("span", getNumberOfNight(booking.checkInDate, booking.checkOutDate) + " " + 
                                        ((getNumberOfNight(booking.checkInDate, booking.checkOutDate) > 1)? messageProvider.get("nights"): messageProvider.get("night")))
                                    ])
                                ])
                            ]),
                            m("div.col-md-4 d-none d-md-block text-right", [
                                m("div.font-weight-bold text-success", "MMK " + new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(booking.totals.sellRate)),
                                m("button.mt-2", {
                                    class: "btn btn-sm btn-outline-secondary shadow-sm mmd-ripple rounded",
                                    onclick: function (event) {
                                        event.preventDefault();
                                        onViewDetails(booking);
                                    },
                                }, m("strong", messageProvider.get("view_details")))
                            ])
                        )
                    ])
                ]),
                m("div.d-block d-md-none", [
                    m("div.row dashed-line pt-2 mt-2", [
                        m("div.col-6 text-muted", m("small", dayjs(booking.createdAt).format("MMM D, hh:mm A"))),
                        m("div.col-6 text-right font-weight-bold text-success", "MMK " + new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(booking.totals.sellRate)),
                    ])
                ])
            ]
        }
    }
}
